// extracted by mini-css-extract-plugin
module.exports = {"icone":"css_icone__2u3Mt","App":"css_App__K1amE"};